import CryptoJS from 'crypto-js';

const KEY = 'GIRSSECRETKEYENC'
const IV =  'GIRSSECRETINVECT'

function encrypter(text: string): string{
    const key = CryptoJS.enc.Utf8.parse(KEY);
    const iv =  CryptoJS.enc.Utf8.parse(IV)
    return CryptoJS.AES.encrypt(text, key, { iv: iv, mode: CryptoJS.mode.CBC}).toString()
}

export default encrypter